import script from "./Back.vue?vue&type=script&setup=true&lang=js"
export * from "./Back.vue?vue&type=script&setup=true&lang=js"

import "./Back.vue?vue&type=style&index=0&id=bd1c9c2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd1c9c2c"]])

export default __exports__